import { LexDatePipe } from '../../../../../../../pipes';
import { AiSummaryTranslocoParameters } from './widget-ai-insights-summary.service';

export default class SentimentVsVolumeSummaryParameters implements AiSummaryTranslocoParameters {
  constructor(private lexDatePipe: LexDatePipe) {}

  assembleParameters(selectedPoints: any[], widget: any) {
    return selectedPoints
      .flatMap((p) => p)
      .map((p, idx) => {
        let translationKey = `widgets.ai-insights.summary.${widget.payload.type}`;
        if (p.series.name === 'total') {
          translationKey = `${translationKey}.total`;
        }

        return {
          translationKey: `${translationKey}.${idx === 0 ? 'first-point' : 'rest-of-points'}`,
          translationParams: {
            fieldValue: widget.payload.selectedItems[0],
            score: p.documentCount ?? p.y,
            sentiment: p.series.name,
            date: this.lexDatePipe.transform(p.category, 'long'),
          },
        };
      });
  }
}
